/* eslint-disable @typescript-eslint/no-explicit-any */
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'
import Button from '@/shared/components/Button/Button'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import styles from './AccordionItemModal.module.scss'
import Modal from '../Modal'
import { useFormDirtyStore } from '@/shared/store/useFormDirtyStore'
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal'

interface AccordionItemModalProps {
  title: string
  accordionItemFormConfig: any
  onClose: () => void
  isOpen: boolean
}

function AccordionItemModal(props: AccordionItemModalProps) {
  const { title, accordionItemFormConfig, onClose, isOpen } = props
  const { t } = useTranslation()
  const setIsDirty = useFormDirtyStore(s => s.setIsDirty)
  const resetIsDirty = useFormDirtyStore(s => s.reset)
  const isDirty = useFormDirtyStore(s => s.isDirty)
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)

  const handleOnConfirmClose = () => {
    resetIsDirty()
    onClose()
    setIsConfirmationModalOpen(false)
  }

  const handleOnClose = () => {
    if (isDirty) {
      setIsConfirmationModalOpen(true)
    } else {
      onClose()
    }
  }

  return (
    <>
      <Modal
        title={title}
        size="fit-content"
        onClose={handleOnClose}
        isOpen={isOpen}
      >
        <div className={styles.accordionItemModalWrapper}>
          <p className={`${styles.accordionItemModalTitle} body-medium`}>
            {t('ACCORDION_ITEM_MODAL.DESCRIPTION')}{' '}
            <mark className="mark-orange">Open AI</mark>
          </p>
          <DynamicForm
            setIsDirty={setIsDirty}
            {...accordionItemFormConfig}
            superCondensed
            formErrorMessage={t('SIDEBAR_ACCORDION.FORM_ERROR_MESSAGE')}
            /*
              The row lives inside the form rather than beside it because
              `footerAction` is the auto-translate button, which reads and writes
              the form through `useFormContext` and therefore has to sit inside
              the provider. Submit keeps working on its own now that it is a
              descendant of the form.
            */
            FormActions={
              <div className={styles.accordionItemModalButtonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  label={t('COMMON.SUBMIT')}
                  type="submit"
                />
                {accordionItemFormConfig.footerAction && (
                  <div className={styles.accordionItemModalTrailingAction}>
                    {accordionItemFormConfig.footerAction}
                  </div>
                )}
              </div>
            }
          />
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onConfirm={handleOnConfirmClose}
        onClose={() => setIsConfirmationModalOpen(false)}
        title={t('CONFIRMATION_MODAL.TITLE')}
        message={t('CONFIRMATION_MODAL.DESCRIPTION')}
      />
    </>
  )
}
export default AccordionItemModal
